/**
 * Single "Add selected frequency as one-time" checkbox below frequency options.
 */
(function () {
  'use strict';

  var globalListenersBound = false;

  function getPickRoot(scope) {
    return scope.closest('[data-pick-plan-product-root]');
  }

  function getProductForm(scope) {
    var root = getPickRoot(scope);
    return (root && root.querySelector('form[data-product-form], form')) || scope.closest('form');
  }

  function getActiveFrequencyRoot(scope) {
    var pickRoot = getPickRoot(scope);
    if (scope.getAttribute('data-bp-add-as-onetime-dual') === 'true' && pickRoot) {
      var panel = pickRoot.querySelector('[data-bp-subscription-panel]:not(.d-none)');
      if (panel) {
        var fs = panel.querySelector('[data-bp-frequency-fieldset]');
        if (fs) return fs;
        var cards = panel.querySelector('[data-frequency-cards]');
        if (cards) return cards;
      }
    }
    var cardsWrap = scope.closest('[data-frequency-cards]');
    if (cardsWrap) return cardsWrap;
    if (pickRoot) {
      return pickRoot.querySelector('[data-frequency-cards]');
    }
    return scope;
  }

  function getVariantPricesForScope(scope) {
    var pickRoot = getPickRoot(scope);
    var el = pickRoot && pickRoot.querySelector('script[data-bp-variant-prices]');
    if (!el || !el.textContent) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function formatMoney(cents) {
    var n = parseInt(cents, 10);
    if (isNaN(n)) n = 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(n, window.theme && window.theme.moneyFormat);
    }
    return '$' + (n / 100).toFixed(2);
  }

  function isRadioRelevantToScope(radio, scope) {
    if (!radio || !scope) return false;
    var pickRoot = getPickRoot(scope);
    if (pickRoot && !pickRoot.contains(radio)) return false;

    if (scope.getAttribute('data-bp-add-as-onetime-dual') === 'true') {
      var panel = radio.closest('[data-bp-subscription-panel]');
      return !!(panel && !panel.classList.contains('d-none'));
    }

    var cards = getActiveFrequencyRoot(scope);
    return !!(cards && cards.contains(radio));
  }

  function getPurchaseOptionRadios(form) {
    if (!form) return { sub: null, ot: null };
    return {
      sub: form.querySelector('input[name="purchase_option"][data-radio-subsave]'),
      ot: form.querySelector('input[name="purchase_option"][data-radio-onetime]')
    };
  }

  function setPurchaseOption(form, oneTime) {
    var po = getPurchaseOptionRadios(form);
    if (form) {
      form.setAttribute('data-bp-purchase-as-onetime', oneTime ? 'true' : 'false');
    }
    if (po.ot && po.sub) {
      if (oneTime) {
        po.ot.checked = true;
        po.sub.checked = false;
        po.ot.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        po.sub.checked = true;
        po.ot.checked = false;
        po.sub.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function getCheckedSubscriptionRadio(root) {
    if (!root) return null;
    var radios = root.querySelectorAll('input[name="selling_plan"]');
    var i;
    for (i = 0; i < radios.length; i++) {
      var r = radios[i];
      if (!r.checked) continue;
      if (r.hasAttribute('data-radio-onetime') || r.value === '') continue;
      if (r.disabled || (r.closest('fieldset') && r.closest('fieldset').disabled)) continue;
      return r;
    }
    return root.querySelector(
      'input[name="selling_plan"]:checked:not([data-radio-onetime])'
    );
  }

  function getOptionDisplayName(rad, card) {
    if (rad) {
      var custom = rad.getAttribute('data-bp-frequency-option-label');
      if (custom && custom.trim()) return custom.trim();
      var aria = rad.getAttribute('aria-label');
      if (aria && aria.trim()) return aria.trim();
    }
    if (card) {
      var titleEl = card.querySelector('.frequency-card__title');
      if (titleEl) {
        var titleText = titleEl.textContent.replace(/\s+/g, ' ').trim();
        if (titleText) return titleText;
      }
    }
    return 'this option';
  }

  function resolveOnetimeUnitPrice(rad, card, scope) {
    if (!rad) return 0;
    var unitPrice = parseInt(rad.getAttribute('data-bp-variant-unit-price'), 10);
    if (!isNaN(unitPrice) && unitPrice > 0) return unitPrice;

    var vid = rad.getAttribute('data-bp-line-variant-id');
    if (vid) {
      var prices = getVariantPricesForScope(scope);
      var v = prices[vid] || prices[String(vid)];
      if (v && v.price != null) {
        unitPrice = parseInt(v.price, 10);
        if (!isNaN(unitPrice) && unitPrice > 0) return unitPrice;
      }
    }

    if (card) {
      var strike = card.querySelector('s[data-recharge-price], s[data-compare-price]');
      if (strike && strike.textContent) {
        var digits = strike.textContent.replace(/[^0-9.]/g, '');
        var parsed = parseFloat(digits);
        if (!isNaN(parsed) && parsed > 0) return Math.round(parsed * 100);
      }
    }

    return 0;
  }

  function getSubscriptionRadioForScope(scope) {
    var visualRoot = getOnetimeVisualRoot(scope);
    var form = getProductForm(scope);
    var root = getActiveFrequencyRoot(scope);
    if (getOnetimeActiveForRoot(visualRoot)) {
      return getStoredSubscriptionRadio(visualRoot, form) || getCheckedSubscriptionRadio(root);
    }
    return getCheckedSubscriptionRadio(root);
  }

  function updateAddAsOnetimeScope(scope) {
    var labelEl = scope.querySelector('[data-bp-add-as-onetime-label]');
    var unitEl = scope.querySelector('[data-bp-add-as-onetime-unit]');
    var totalEl = scope.querySelector('[data-bp-add-as-onetime-total]');
    var rad = getSubscriptionRadioForScope(scope);
    if (!rad || rad.value === '') return;

    var card = rad.closest('[data-frequency-card]');
    if (labelEl) {
      labelEl.textContent = getOptionDisplayName(rad, card);
    }

    var qty = parseInt(rad.getAttribute('data-quantity'), 10) || 1;
    var unitPrice = resolveOnetimeUnitPrice(rad, card, scope);

    if (unitEl) {
      unitEl.textContent = unitPrice > 0 ? formatMoney(unitPrice) : '';
    }
    if (totalEl) {
      if (unitPrice > 0) {
        totalEl.textContent = 'Total: ' + formatMoney(unitPrice * qty);
        totalEl.style.display = '';
      } else {
        totalEl.textContent = '';
        totalEl.style.display = 'none';
      }
    }
  }

  function getOnetimeVisualRoot(scope) {
    return getPickRoot(scope) || getProductForm(scope);
  }

  function isSubscriptionFrequencyCard(card) {
    if (!card || card.classList.contains('frequency-card--onetime')) return false;
    var radio = card.querySelector('input[name="selling_plan"]');
    return isSubscriptionSellingPlanRadio(radio);
  }

  function getActiveSubscriptionCardsRoot(visualRoot) {
    if (!visualRoot) return null;
    var panel = visualRoot.querySelector('[data-bp-subscription-panel]:not(.d-none)');
    if (panel) {
      return (
        panel.querySelector('[data-frequency-cards]') ||
        panel.querySelector('[data-bp-frequency-fieldset]')
      );
    }
    return visualRoot.querySelector('[data-frequency-cards]');
  }

  function getOnetimeActiveForRoot(visualRoot) {
    if (!visualRoot) return false;
    if (visualRoot.querySelector('[data-bp-add-as-onetime]:checked')) return true;
    var form =
      visualRoot.tagName === 'FORM'
        ? visualRoot
        : visualRoot.querySelector('form[data-product-form], form');
    return !!(
      form &&
      (form.getAttribute('data-bp-purchase-as-onetime') === 'true' ||
        (form.querySelector('input[name="purchase_option"][data-radio-onetime]') &&
          form.querySelector('input[name="purchase_option"][data-radio-onetime]').checked))
    );
  }

  function storeSelectedSubscriptionRadio(visualRoot, form, radio) {
    if (!form) return;
    if (!radio) {
      var activeRoot = getActiveSubscriptionCardsRoot(visualRoot) || visualRoot;
      radio = getCheckedSubscriptionRadio(activeRoot);
      if (!radio) radio = getStoredSubscriptionRadio(visualRoot, form);
    }
    if (!radio) return;
    form.setAttribute('data-bp-stored-selling-plan-id', radio.value);
    form.setAttribute('data-bp-stored-selling-plan-qty', radio.getAttribute('data-quantity') || '1');
    if (radio.getAttribute('data-bp-line-variant-id')) {
      form.setAttribute('data-bp-stored-line-variant-id', radio.getAttribute('data-bp-line-variant-id'));
    } else {
      form.removeAttribute('data-bp-stored-line-variant-id');
    }
    var panel = radio.closest('[data-bp-subscription-panel]');
    if (panel) {
      form.setAttribute('data-bp-stored-subscription-panel', panel.getAttribute('data-bp-subscription-panel') || '');
    } else {
      form.removeAttribute('data-bp-stored-subscription-panel');
    }
  }

  function getStoredSubscriptionRadio(visualRoot, form) {
    if (!form || !visualRoot) return null;
    var planId = form.getAttribute('data-bp-stored-selling-plan-id');
    if (!planId) return null;

    var storedPanel = form.getAttribute('data-bp-stored-subscription-panel');
    var searchRoots = [];
    if (storedPanel) {
      var panel = visualRoot.querySelector('[data-bp-subscription-panel="' + storedPanel + '"]');
      if (panel) searchRoots.push(panel);
    }
    var activeRoot = getActiveSubscriptionCardsRoot(visualRoot);
    if (activeRoot && searchRoots.indexOf(activeRoot) < 0) searchRoots.push(activeRoot);
    searchRoots.push(visualRoot);

    var i;
    var j;
    for (i = 0; i < searchRoots.length; i++) {
      var radios = searchRoots[i].querySelectorAll('input[name="selling_plan"]');
      for (j = 0; j < radios.length; j++) {
        if (radios[j].value === planId && isSubscriptionSellingPlanRadio(radios[j])) {
          return radios[j];
        }
      }
    }

    var qty = form.getAttribute('data-bp-stored-selling-plan-qty');
    var fallbackRoot = getActiveSubscriptionCardsRoot(visualRoot) || visualRoot;
    var fallback = null;
    fallbackRoot.querySelectorAll('input[name="selling_plan"]').forEach(function (r) {
      if (!isSubscriptionSellingPlanRadio(r)) return;
      if (String(r.getAttribute('data-quantity')) === String(qty)) fallback = r;
    });
    return fallback;
  }

  function uncheckAllSubscriptionRadios(visualRoot) {
    if (!visualRoot) return;
    visualRoot.querySelectorAll('input[name="selling_plan"]').forEach(function (radio) {
      if (!isSubscriptionSellingPlanRadio(radio)) return;
      radio.checked = false;
      radio.removeAttribute('checked');
    });
    visualRoot.querySelectorAll('[data-frequency-card]').forEach(function (card) {
      if (isSubscriptionFrequencyCard(card)) {
        card.classList.remove('frequency-card--selected');
        card.classList.add('frequency-card--subscription-muted');
      }
    });
  }

  function restoreStoredSubscriptionRadio(visualRoot, form) {
    if (!form || !visualRoot) return null;
    visualRoot.querySelectorAll('[data-frequency-card]').forEach(function (card) {
      if (isSubscriptionFrequencyCard(card)) {
        card.classList.remove('frequency-card--subscription-muted');
      }
    });
    visualRoot.querySelectorAll('input[name="selling_plan"]').forEach(function (radio) {
      if (!isSubscriptionSellingPlanRadio(radio)) return;
      radio.checked = false;
      radio.removeAttribute('checked');
    });
    var stored = getStoredSubscriptionRadio(visualRoot, form);
    if (!stored) return null;
    stored.checked = true;
    stored.setAttribute('checked', 'checked');
    return stored;
  }

  function setSubscriptionCardsMuted(visualRoot, muted) {
    if (!visualRoot) return;
    visualRoot.querySelectorAll('[data-frequency-card]').forEach(function (card) {
      if (!isSubscriptionFrequencyCard(card)) return;
      card.classList.toggle('frequency-card--subscription-muted', !!muted);
      if (muted) {
        card.classList.remove('frequency-card--selected');
      }
    });
    visualRoot.querySelectorAll('[data-frequency-cards]').forEach(function (wrap) {
      if (muted) {
        wrap.setAttribute('data-bp-subscription-visual-muted', 'true');
      } else {
        wrap.removeAttribute('data-bp-subscription-visual-muted');
      }
    });
  }

  function restoreSubscriptionCardSelection(visualRoot) {
    if (!visualRoot) return;
    var activeRoot = getActiveSubscriptionCardsRoot(visualRoot) || visualRoot;
    var checked = getCheckedSubscriptionRadio(activeRoot);
    visualRoot.querySelectorAll('[data-frequency-card]').forEach(function (card) {
      if (!isSubscriptionFrequencyCard(card)) return;
      if (!activeRoot.contains(card)) {
        card.classList.remove('frequency-card--selected');
        return;
      }
      card.classList.toggle('frequency-card--selected', !!checked && card.contains(checked));
    });
  }

  function toggleOnetimeActiveMarkers(visualRoot, onetimeActive) {
    if (!visualRoot) return;
    visualRoot.classList.toggle('bp-onetime-active', onetimeActive);
    var section = visualRoot.closest('.pick-plan-button, .shopify-section');
    if (section) section.classList.toggle('bp-onetime-active', onetimeActive);
    var form =
      visualRoot.tagName === 'FORM'
        ? visualRoot
        : visualRoot.querySelector('form[data-product-form], form');
    if (form) form.classList.toggle('bp-onetime-active', onetimeActive);
    visualRoot.querySelectorAll('.selling-plan-fieldset, [data-bp-dual-subscription-panels]').forEach(
      function (el) {
        el.classList.toggle('bp-onetime-active', onetimeActive);
      }
    );
  }

  function ensureSubscriptionRadiosMatchOnetimeState(visualRoot, onetimeActive) {
    if (!visualRoot) return;
    var form =
      visualRoot.tagName === 'FORM'
        ? visualRoot
        : visualRoot.querySelector('form[data-product-form], form');
    if (onetimeActive) {
      var activeRoot = getActiveSubscriptionCardsRoot(visualRoot) || visualRoot;
      var checked = getCheckedSubscriptionRadio(activeRoot);
      if (checked) {
        storeSelectedSubscriptionRadio(visualRoot, form, checked);
      }
      uncheckAllSubscriptionRadios(visualRoot);
      return;
    }
    if (form && form.getAttribute('data-bp-stored-selling-plan-id')) {
      var hasChecked = !!getCheckedSubscriptionRadio(getActiveSubscriptionCardsRoot(visualRoot) || visualRoot);
      if (!hasChecked) {
        restoreStoredSubscriptionRadio(visualRoot, form);
      }
    }
  }

  function syncOnetimeVisualForRoot(visualRoot) {
    if (!visualRoot) return;
    var onetimeActive = getOnetimeActiveForRoot(visualRoot);
    ensureSubscriptionRadiosMatchOnetimeState(visualRoot, onetimeActive);
    toggleOnetimeActiveMarkers(visualRoot, onetimeActive);
    setSubscriptionCardsMuted(visualRoot, onetimeActive);
    if (!onetimeActive) {
      restoreSubscriptionCardSelection(visualRoot);
    }
  }

  function syncOnetimeVisualForScope(scope) {
    syncOnetimeVisualForRoot(getOnetimeVisualRoot(scope));
  }

  function scheduleOnetimeVisualSync(scope) {
    syncOnetimeVisualForScope(scope);
    requestAnimationFrame(function () {
      syncOnetimeVisualForScope(scope);
    });
  }

  function syncAllOnetimeVisual() {
    var roots = [];
    document.querySelectorAll('[data-bp-add-as-onetime-scope]').forEach(function (scope) {
      var root = getOnetimeVisualRoot(scope);
      if (root && roots.indexOf(root) < 0) roots.push(root);
    });
    roots.forEach(syncOnetimeVisualForRoot);
  }

  function setOnetimeChecked(scope, checked, opts) {
    opts = opts || {};
    var checkbox = scope.querySelector('[data-bp-add-as-onetime]');
    if (!checkbox) return;
    var form = getProductForm(scope);
    var visualRoot = getOnetimeVisualRoot(scope);
    checkbox.checked = !!checked;
    scope.classList.toggle('frequency-add-onetime-option--active', !!checked);
    if (form) {
      form.setAttribute('data-bp-purchase-as-onetime', checked ? 'true' : 'false');
    }

    if (checked) {
      storeSelectedSubscriptionRadio(visualRoot, form);
      uncheckAllSubscriptionRadios(visualRoot);
    } else if (!opts.skipSubscriptionRestore) {
      if (opts.keepCurrentSubscription) {
        var activeRoot = getActiveSubscriptionCardsRoot(visualRoot) || visualRoot;
        var current = getCheckedSubscriptionRadio(activeRoot);
        if (current) storeSelectedSubscriptionRadio(visualRoot, form, current);
      } else {
        var restored = restoreStoredSubscriptionRadio(visualRoot, form);
        if (restored) {
          restored.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    setPurchaseOption(form, !!checked);
    scheduleOnetimeVisualSync(scope);
    updateAddAsOnetimeScope(scope);
  }

  function clearOnetimeSelection(scope, opts) {
    setOnetimeChecked(scope, false, opts || { keepCurrentSubscription: true });
  }

  function isSubscriptionSellingPlanRadio(radio) {
    return !!(
      radio &&
      radio.name === 'selling_plan' &&
      radio.type === 'radio' &&
      radio.value !== '' &&
      !radio.hasAttribute('data-radio-onetime')
    );
  }

  function clearOnetimeForPickRoot(pickRoot) {
    if (!pickRoot) return;
    pickRoot.querySelectorAll('[data-bp-add-as-onetime-scope]').forEach(clearOnetimeSelection);
  }

  function handleSubscriptionFrequencyChange(target) {
    document.querySelectorAll('[data-bp-add-as-onetime-scope]').forEach(function (scope) {
      if (!isRadioRelevantToScope(target, scope)) return;
      clearOnetimeSelection(scope);
      updateAddAsOnetimeScope(scope);
    });
  }

  function updateAllScopes() {
    document.querySelectorAll('[data-bp-add-as-onetime-scope]').forEach(updateAddAsOnetimeScope);
    syncAllOnetimeVisual();
  }

  function bindGlobalListeners() {
    if (globalListenersBound) return;
    globalListenersBound = true;

    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t) return;

        if (t.matches && t.matches('[data-bp-add-as-onetime]')) {
          var otScope = t.closest('[data-bp-add-as-onetime-scope]');
          if (otScope) {
            if (otScope.getAttribute('data-bp-add-as-onetime-bound') !== 'true') {
              initScope(otScope, { skipInitialPurchaseSync: true });
            }
            setOnetimeChecked(otScope, t.checked);
          }
          return;
        }

        if (t.name === 'selling_plan' && t.type === 'radio' && isSubscriptionSellingPlanRadio(t)) {
          handleSubscriptionFrequencyChange(t);
          return;
        }

        if (t.hasAttribute && t.hasAttribute('data-bp-subscription-panel-trigger')) {
          clearOnetimeForPickRoot(getPickRoot(t));
        }

        if (t.name === 'purchase_option' && t.type === 'radio') {
          syncAllOnetimeVisual();
        }
      },
      true
    );

    document.addEventListener(
      'click',
      function (e) {
        var card = e.target && e.target.closest && e.target.closest('[data-frequency-card]');
        if (!card || card.classList.contains('frequency-card--onetime')) return;
        var radio = card.querySelector('input[name="selling_plan"]');
        if (!isSubscriptionSellingPlanRadio(radio)) return;

        requestAnimationFrame(function () {
          document.querySelectorAll('[data-bp-add-as-onetime-scope]').forEach(function (scope) {
            var root = getActiveFrequencyRoot(scope);
            if (root && root.contains(card)) {
              clearOnetimeSelection(scope);
              updateAddAsOnetimeScope(scope);
            }
          });
        });
      },
      true
    );
  }

  function initScope(scope, opts) {
    opts = opts || {};
    if (scope.getAttribute('data-bp-add-as-onetime-bound') === 'true') return;
    var checkbox = scope.querySelector('[data-bp-add-as-onetime]');
    if (!checkbox) return;
    scope.setAttribute('data-bp-add-as-onetime-bound', 'true');

    var form = getProductForm(scope);
    if (!opts.skipInitialPurchaseSync) {
      var po = getPurchaseOptionRadios(form);
      if (po.ot && po.ot.checked) {
        setOnetimeChecked(scope, true);
      } else {
        setPurchaseOption(form, false);
      }
    }

    updateAddAsOnetimeScope(scope);
  }

  function boot() {
    bindGlobalListeners();
    document.querySelectorAll('[data-bp-add-as-onetime-scope]').forEach(initScope);
    updateAllScopes();
    syncAllOnetimeVisual();
  }

  function resolveActiveSellingPlanRadio(form, sectionRoot) {
    if (!form) return null;
    var visualRoot = sectionRoot || getPickRoot(form) || form;
    if (getOnetimeActiveForRoot(visualRoot)) {
      return getStoredSubscriptionRadio(visualRoot, form);
    }
    if (visualRoot.querySelector('[data-bp-dual-subscription-panels]')) {
      var fs = visualRoot.querySelector('[data-bp-frequency-fieldset]:not([disabled])');
      return fs ? getCheckedSubscriptionRadio(fs) : null;
    }
    return getCheckedSubscriptionRadio(form);
  }

  window.__bpInitAddAsOnetimeScopes = boot;
  window.__bpUpdateAddAsOnetimeLabels = updateAllScopes;
  window.__bpSyncOnetimeVisualState = syncAllOnetimeVisual;
  window.__bpResolveActiveSellingPlanRadio = resolveActiveSellingPlanRadio;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
